import { cn } from "@/lib/utils";
import React from "react";

const Skeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): React.ReactNode => {
  return (
    <div
      className={cn("animate-pulse rounded-xl bg-secondary-light", className)}
      {...props}
    />
  );
};

export { Skeleton };
